import { Paper, Table, TableBody, TableCell, TableHead, TableRow, WithStyles, withStyles,Typography } from '@material-ui/core';
import React, { Component } from 'react';
import bulkReportOperation from '../styles/BulkReportOperation';
import { getBulkReport } from "../actions/courseManagementActions";
import { connect } from 'react-redux';
import moment from "moment";
import { createErrorSheet } from '../helpers/helpers';
import courseService from '../../course/services/courseService';
import ContentPagination from '../../mylibrary/components/ContentPagination';
import { withRouter } from 'react-router-dom';

interface BulkReportOperationProps extends WithStyles<typeof bulkReportOperation> {
    bulkReport: any,
    bulkReportCount: number,
    classes: any;
    getBulkReport: Function,
    history: any,
}

interface BulkReportOperationState {
    currentReportPageNo: number,
}

class BulkReportOperation extends Component<BulkReportOperationProps, BulkReportOperationState> {
    constructor(props: any) {
        super(props);
        this.state = {
          currentReportPageNo: 1,
        };
    }
    componentDidMount(): void {
      this.props.getBulkReport(1);
    }

    getOperationType(type: string) {
      switch(type) {
        case 'bulkImportScheduledTests' : return 'Bulk Import Scheduled Tests';
        case 'mapScheduledTests': return'Map Scheduled Tests';
        case 'bulkAddContent': return 'Bulk Add Content';
        case 'bulkEditContent': return 'Bulk Edit Content';
        case 'bulkRemoveContent': return 'Bulk Remove Content';
      }
  
    }

    getResponseSheet(id: string, type: string) {
      courseService.getResponseSheet(id)
      .then((res: any) => {
          if (res.statusCode == 200) {
              if(res.responseObject.detailedReport && type === 'bulkImportScheduledTests'){
                  const data:any[]=[];
                  res.responseObject.detailedReport.forEach((err:any)=>{
                    const obj:any={};
                    for(let key in err){
                      if(key === "sku" || key === "reasons" || key === "status" || key === "mainTestCount" || key === "milestoneTestCount" ) {
                        obj["sku".toUpperCase()] = err["sku"];
                        obj["mainTestCount".toUpperCase()] = err["mainTestCount"] ? err["mainTestCount"] : 0;
                        obj["milestoneTestCount".toUpperCase()] = err["milestoneTestCount"] ? err["milestoneTestCount"] : 0;
                        obj["status".toUpperCase()] = err["status"];
                        obj["reasons".toUpperCase()] = err["reasons"].join(",");
                      }
                    }
                    data.push(obj);
                  })
                  if(data.length==res.responseObject.detailedReport.length){
                      createErrorSheet(data,'Response_Sheet.xlsx');
                  }
              } else if(res.responseObject.detailedReport && type === 'mapScheduledTests') {
                const data:any[]=[];
                res.responseObject.detailedReport.forEach((err:any)=>{
                  const obj:any={};
                  for(let key in err){
                    if(key === "sku" || key === "reasons" || key === "primaryTestName" || key === "testId" || key === "status" ) {
                      obj["primary test name".toUpperCase()] = err["primaryTestName"];
                      obj["sku".toUpperCase()] = err["sku"];
                      obj["test id".toUpperCase()] = err["testId"] ? err["testId"] : '';
                      obj["status".toUpperCase()] = err["status"];
                      if(err["reasons"].length > 0) {
                        obj["remarks".toUpperCase()] = err["reasons"].join(",");
  
                      }
                    }
                  }
                  data.push(obj);
                })
                if(data.length==res.responseObject.detailedReport.length){
                    createErrorSheet(data,'Response_Sheet.xlsx');
                }
              }else if(res.responseObject.detailedReport && type === 'bulkAddContent'){
                const data:any[]=[];
                res.responseObject.detailedReport.forEach((err:any)=>{
                  const obj:any={};
                  for(let key in err){
                    if(key === "sku" || key === "reasons" || key === "testName" || key === "selectedContent" || key === "status" ) {
                     obj["sku".toUpperCase()] = err["sku"];
                      obj["selectedContent".toUpperCase()] = err["selectedContent"];
                      obj["addedContent".toUpperCase()] = err["addedContent"];
                      obj["status".toUpperCase()] = err["status"];
                      if(err["reasons"].length > 0) {
                        obj["error".toUpperCase()] = err["reasons"].join(",");
  
                      }
                    }
                  }
                  data.push(obj);
                })
                if(data.length==res.responseObject.detailedReport.length){
                    createErrorSheet(data,'Response_Sheet.xlsx');
                }
              }else if(res.responseObject.detailedReport && type === 'bulkEditContent'){
                const data:any[]=[];
                res.responseObject.detailedReport.forEach((err:any)=>{
                  const obj:any={};
                  for(let key in err){
                    if(key === "sku" || key === "reasons" || key === "testName" || key === "selectedContent" || key === "status" ) {
                     obj["sku".toUpperCase()] = err["sku"];
                     obj["status".toUpperCase()] = err["status"];
                      if(err["reasons"].length > 0) {
                        obj["reasons".toUpperCase()] = err["reasons"].join(",");
  
                      }
                    }
                  }
                  data.push(obj);
                })
                if(data.length==res.responseObject.detailedReport.length){
                    createErrorSheet(data,'Response_Sheet.xlsx');
                }
              }
              else if(res.responseObject.detailedReport && type === 'bulkRemoveContent'){
                const data:any[]=[];
                res.responseObject.detailedReport.forEach((err:any)=>{
                  const obj:any={};
                  for(let key in err){
                    if(key === "sku" || key === "reasons" || key === "testName" || key === "selectedContent" || key === "status" ) {
                     obj["sku".toUpperCase()] = err["sku"];
                      obj["selectedContent".toUpperCase()] = err["selectedContent"];
                      obj["removedContent".toUpperCase()] = err["removedContent"];
                      obj["status".toUpperCase()] = err["status"];
                      if(err["reasons"].length > 0) {
                        obj["reasons".toUpperCase()] = err["reasons"].join(",");
  
                      }
                    }
                  }
                  data.push(obj);
                })
                if(data.length==res.responseObject.detailedReport.length){
                    createErrorSheet(data,'Response_Sheet.xlsx');
                }
              }
          }
      })
    }
    onPageChangeReport(page: number) {
      this.setState({currentReportPageNo: page})
      this.props.getBulkReport(page);
    }
    handleBackButton = (event: any) => {
      this.props.history.push('/course-Management');
    }
    render() {
      const { currentReportPageNo } = this.state;
      const { classes, bulkReport, bulkReportCount } = this.props;
        return (
            <div>
              <div className='bulkReportOperationBlock'>
                <div className={classes.pageHeadingRow}>
                  <h2 className={classes.pageHeading}>
                    <img src='/assets/svg/left-arrow.svg' alt='Back Arrow' onClick={this.handleBackButton}  /> 
                    Bulk Operation Report
                  </h2>
                  <div className={classes.paginationBlock}>
                    <ContentPagination
                      page={currentReportPageNo}
                      count={bulkReportCount}
                      rowsPerPage={10}
                      onChangePage={(
                        e: any,
                        page: number
                      ) => {
                        this.onPageChangeReport(page);
                      }}
                    />   
                  </div> 
                </div>   
              </div>     
                <Paper className={classes.tableContainer}>
                          <Table className={`${classes.table} ${classes.bulkReportrow}`}>
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  {" "}
                                  <h3>S.No</h3>{" "}
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Operation Type</h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Initiated At</h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>
                                  Content Count 
                                  </h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>
                                    Total Courses
                                  </h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Processing Status</h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Completed At</h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Status</h3>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {bulkReport &&
                                bulkReport.map((ele: any, index: number) => {
                                  const initiateDate = moment(ele.createdAt).format('DD/MM/YYYY');
                                  const initiateTime = moment(ele.createdAt).format('hh:mm A');
                                  const completeDate = ele.completedAt && moment(ele.completedAt).format('DD/MM/YYYY');
                                  const completeTime = ele.completedAt && moment(ele.completedAt).format('hh:mm A');
                                  let progressPercent: any = 0;
                                  if(ele.totalProcessedCoursesCount && ele.totalProcessedCoursesCount >= 0) {
                                    progressPercent = ele.totalProcessedCoursesCount % ele.destinationCoursesCount !== 0 ? (((ele.totalProcessedCoursesCount / ele.destinationCoursesCount) * 100).toFixed(2)) : ((ele.totalProcessedCoursesCount / ele.destinationCoursesCount) * 100); 

                                  } else {
                                    progressPercent = 0;
                                  }
                                  return (
                                    <TableRow
                                      className={classes.row}
                                    >
                                      <TableCell
                                        component="th"
                                        scope="row"
                                      >
                                        {currentReportPageNo > 1 ? (((currentReportPageNo - 1)  * 10 ) + index + 1) : index + 1}
                                      </TableCell>
                                      <TableCell align="center">
                                        {this.getOperationType(ele.type)}
                                      </TableCell>
                                      <TableCell align="center">
                                        {initiateDate}, &nbsp;{initiateTime}
                                      </TableCell>
                                      <TableCell align="center">
                                        {ele.scheduleTestsCount}
                                      </TableCell>
                                      <TableCell align="center">
                                        {
                                          ele.destinationCoursesCount
                                        }
                                      </TableCell>
                                      <TableCell align="center">
                                        {ele.totalProcessedCoursesCount} ( <span className={classes.green}>{ele.successfulCoursesCount || 0}</span> <span className={classes.red}>{ele.failedCoursesCount || 0}</span> )
                                      </TableCell>
                                      <TableCell align="center">
                                      {ele.completedAt ? completeDate + ', ' + completeTime : '-' }
                                      </TableCell>
                                      <TableCell align="center" className={classes.textCapitalize}>
                                        <span>{ele.status === "inProgress" ? 'In Progress' : ele.status}</span>
                                        {ele.status !==
                                          "inProgress" && (
                                          <Typography className={classes.cursor} color="primary" onClick={() => this.getResponseSheet(ele._id, ele.type)}>
                                            Response Sheet
                                          </Typography>
                                        )}
                                        {
                                          ele.status === 
                                          "inProgress" && (
                                            <div className={classes.progressContainer}>
                                            <progress id="file" value={progressPercent} max="100"> {progressPercent}%</progress>
                                            <span> {progressPercent + '%'}</span>
                                            </div>
                                          )
                                        }
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                            </TableBody>
                          </Table>
                        </Paper>
            </div>
        );
    }
}


const mapStateToProps = (state: any) => ({
    bulkReport: state.courseMangementData.courseManagementReducer.bulkReport,
    bulkReportCount: state.courseMangementData.courseManagementReducer.bulkReportCount,
});

const mapDispatchToProps = {
    getBulkReport,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
)(withRouter(withStyles(bulkReportOperation)(BulkReportOperation)));